import React, { useState } from 'react';

export interface MoreBubbleItem {
  label:string
  action?: ()=> void
}

interface MoreBubbleProps {
  items: MoreBubbleItem[];
  className?: string;
}

const MoreBubble: React.FC<MoreBubbleProps> = ({ items, className = '' }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // NB : rendu dans le render() d'une colonne de GenericTable, déjà enveloppé dans un <td>.
  // La racine doit donc être un <div> (un <td> imbriqué est du DOM invalide).
  if (!items || items.length === 0) {
    return <div className={`text-gray-400 ${className}`}>Aucun élément</div>;
  }

  const firstItem = items[0];
  const remainingItems = items.slice(1);
  const hasMore = remainingItems.length > 0;

  return (
    <div className={`${className}`}>
      <div className="space-y-1">
        {/* Premier élément toujours visible */}
        <div className="flex items-center gap-2">
          <span className={`text-sm ${firstItem.action && "cursor-pointer hover:underline"}`} onClick={firstItem.action}>{firstItem.label}</span>

          {/* Indicateur et bouton toggle si il y a d'autres éléments */}
          {hasMore && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className={`flex items-center gap-1 px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-full hover:bg-blue-200 transition-colors`}
            >
              <span>+{remainingItems.length}</span>
              <svg
                className={`w-3 h-3 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          )}
        </div>

        {/* Éléments supplémentaires (affichés/cachés selon l'état) */}
        {hasMore && isExpanded && (
          <div className={`pl-2 border-l-2 border-gray-200 space-y-1`}>
            {remainingItems.map((item, index) => (
              <div onClick={item.action} key={index} className={`text-sm text-gray-600 ${item.action && 'cursor-pointer hover:underline'}`}>
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreBubble;
